export const STREAMID_CODEC = 206;
//# sourceMappingURL=constants.js.map